export default __webpack_public_path__ + "static/media/banner-default-img.adc0de11.svg";